import React from 'react'
import {Table} from 'react-bootstrap'
import {t} from '../../helpers/translate'

class AssociatedApplicantComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
        <Table striped condensed hover id='associatedApplicantTable'>
          <thead>
          <tr>
            <th className="col-md-4">{t('Policy Number')}</th>
            <th className="col-md-4">{t('First Name')}</th>
            <th className="col-md-4">{t('Last Name')}</th>
          </tr>
          </thead>
          <tbody>
	          {
	          	this.props.associatedApplicants.map(
	          		(applicant, index) => <tr>
			            <td className="col-md-4">{applicant.policy_number}</td>
			            <td className="col-md-4">{applicant.first_name}</td>
			            <td className="col-md-4">{applicant.last_name}</td>
	          		</tr>
	      		)
	          }
          </tbody>
        </Table>);
  }
}

AssociatedApplicantComponent.displayName = 'AssociatedApplicantComponent';
export default AssociatedApplicantComponent;



// WEBPACK FOOTER //
// ./src/components/common/AssociatedApplicantComponent.js